import { Component } from 'react';

import { axiosInstance, cancelToken } from '../../utils/axiosInstance';
import { endpoint } from '../../utils/constants';
import { errorHandling, hasModuleAccess } from '../../utils/helpers';
import TableWrapper from '../Tables/TableWrapper';
import TitleHeader from '../TitleHeader/TitleHeader';

class GatewaysList extends Component {
    state = {
        loading: false,
        content: {
            data: [],
            headers: {},
        },
    };

    componentDidMount() {
        this.cancelHttpReq = cancelToken.source();
        this.fetchEndpoint();
    }

    componentWillUnmount() {
        this.cancelHttpReq.cancel();
    }

    fetchEndpoint = () => {
        this.setState({ loading: true });

        axiosInstance
            .get(endpoint.GATEWAY_SHOW, {
                cancelToken: this.cancelHttpReq.token,
            })
            .then(content => {
                this.setState({
                    loading: false,
                    content: {
                        headers: content.data.headers,
                        data: content.data.data,
                    },
                });
            })
            .catch(err => {
                errorHandling(err, this);
            });
    };

    render() {
        const { content, loading, isServerError } = this.state;

        return (
            hasModuleAccess('gateways') && (
                <div>
                    <TitleHeader title={'Lista bramek'} />

                    <TableWrapper
                        hidePagination
                        isThrobberActive={loading}
                        content={content}
                        isServerError={isServerError}
                    />
                </div>
            )
        );
    }
}

export default GatewaysList;
